module.exports = __webpack_public_path__ + "static/pic01.87b25bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic01.jpg
// module id = 484
// module chunks = 114276838955818